/* COLOR HELPERS */
.danger {
  color: var(--red-layout-300-primary);
}

.accent {
  color: var(--blue-layout-400-primary);
}

.warning {
  color: var(--orange-layout-050-warning);
}

.notice {
  color: var(--yellow-alert-050);
}

.gray {
  color: var(--grey-layout-200-disabled);
}

.success {
  color: var(--green-layout-100-primary-green);
}
